import React, {useMemo} from 'react';
import GlobalConst from "../../../../constants/GlobalConst";
import Currency from "../../../Currency/Currency";
import {useIntl} from "react-intl";
import './CreateYourOwnPicksBanner.style.scss';

const getPlayerPictureUrl = (contest) =>
    `${GlobalConst.CDN.BASEURL}images/Players/${GlobalConst.LEAGUES_BY_SPORT_ID[contest.SportId]}/${contest.PlayerId}.png`;

const formatMultiplier = (mult) =>
    `x${mult > 100 ? Math.round(mult) : mult.toFixed(1).replace(/\.?0+$/, '')}`;

const MIN_DISPLAY = GlobalConst.CUSTOM_PARLAY.MIN_PLAYERS;
const tKey = "lobbyView.contests.customContest.customParlayTable";

const CreateYourOwnPicksBanner = ({parlay, contests = [], onViewPicks, onSubmit, disableSubmit}) => {
    const intl = useIntl();
    const payoutInfos = useMemo(() => {
        if (!contests.length || !parlay) return [];
        try {
            const effectiveFee = parlay.Wager || GlobalConst.CUSTOM_PARLAY.FEES[0];
            const parlayForCalc = Object.assign(
                Object.create(Object.getPrototypeOf(parlay)),
                parlay,
                {Wager: effectiveFee}
            );
            return parlayForCalc.getPayouts(contests, 0.0) ?? [];
        } catch { return []; }
    }, [parlay, contests]);

    const totalContests = parlay?.totalContests ?? 0;
    const maxSlots = GlobalConst.CUSTOM_PARLAY.MAX_PLAYERS;
    const fee = parlay?.Wager || GlobalConst.CUSTOM_PARLAY.FEES[0];
    const currency = parlay?.WagerCurrency || GlobalConst.SITE_CURRENCY;
    const emptyCount = Math.max(0, MIN_DISPLAY - totalContests);

    const showButtons = onSubmit !== undefined;

    return (
        <div className="CreateYourOwnPicksBanner">
            <div className="banner-top" onClick={onViewPicks}>
                <div className="picks-row">
                    {contests.map((c, i) => (
                        <div key={i} className="pick-slot">
                            <div className="avatar filled"
                                 style={{backgroundImage: `url(${getPlayerPictureUrl(c)})`}}/>
                            <span className="pick-number">{i + 1}</span>
                        </div>
                    ))}
                    {Array.from({length: emptyCount}).map((_, i) => (
                        <div key={`empty-${i}`} className="pick-slot">
                            <div className="avatar empty"/>
                            <span className="pick-number">{totalContests + i + 1}</span>
                        </div>
                    ))}
                    {totalContests < maxSlots && (
                        <div className="pick-slot">
                            <div className="avatar add">+</div>
                            <span className="pick-number"/>
                        </div>
                    )}
                </div>

                {totalContests < MIN_DISPLAY && (
                    <span className="min-hint">
                        {intl.formatMessage(
                            {id: totalContests === 0 ? `${tKey}.addParenthesisMin` : `${tKey}.addParenthesisMissing`},
                            {x: MIN_DISPLAY - totalContests}
                        ).replace(/^\(|\)$/g, '')}
                    </span>
                )}

                <div className="total-winning">
                    <div className={`formula ${payoutInfos.length > 1 ? 'multi' : ''}`}>
                        {payoutInfos.map((p, i) => (
                            <span key={i} className="payout-line">
                                <span className="correct">{p.correct}/{p.total}:</span>
                                {i === 0 && <Currency value={Number(fee)} currency={currency} removeDecimal className="wager"/>}
                                <span className="multiplier-label">{formatMultiplier(p.multiplier)}</span>
                                <span className="correct">=</span>
                                <Currency value={Number(p.payout)} currency={currency} removeDecimal className="gold-gradient-text"/>
                            </span>
                        ))}
                    </div>
                    <i className="fa-solid fa-chevron-right cta-icon"/>
                </div>
            </div>

            {showButtons && (
                <div className="banner-buttons">
                    <button
                        className="btn-change"
                        onClick={(e) => { e.stopPropagation(); onViewPicks?.(); }}
                    >
                        {intl.formatMessage({id: `${tKey}.changePicks`})}
                    </button>
                    <button
                        className="btn-submit"
                        onClick={(e) => { e.stopPropagation(); onSubmit?.(); }}
                        disabled={disableSubmit}
                    >
                        {intl.formatMessage({id: `${tKey}.submitPicks`})}
                    </button>
                </div>
            )}
        </div>
    );
};

export default CreateYourOwnPicksBanner;
